<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M2 16.2V7V6.2C2 5.0799 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.0799 3 5.2 3H9.02229C9.74021 3 10.0992 3 10.4161 3.10931C10.6963 3.20597 10.9516 3.36373 11.1634 3.57116C11.4029 3.80573 11.5634 4.1268 11.8845 4.76892L13 7H14.2"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
    <path
      d="M6.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.8025 20.4486 19.1787 20.1198 19.4594 19.718C19.4615 19.7149 19.4562 19.7226 19.5254 19.6007C19.5595 19.5406 19.6627 19.3292 19.6891 19.2653C19.7426 19.1358 19.7602 19.0788 19.7952 18.9648L22 11.8C22.4688 10.2188 22.1707 9.36049 21.8438 8.71875C21.5561 8.15426 20.9265 7.6146 20.362 7.32698C19.7202 7 18.8802 7 17.2 7H6L2.39806 15.2845C2.24753 15.6307 2.17226 15.8038 2.11906 15.9864C2.07315 16.144 2.03779 16.3192 2.01901 16.4823C1.99724 16.6712 1.99934 16.847 2.00354 17.1985C2.01599 18.2421 2.07232 18.8622 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
